import { Provider as AlertProvider } from 'react-alert'
import { useTranslation } from 'react-i18next'
import { BrowserRouter as Router } from 'react-router-dom'

import { ALERT_HIDE_TIMEOUT, ALERT_STYLE } from '../../config/constants'
import { useAuth } from '../../hooks/useAuth'
import AppRouter from '../../routes/AppRoute'
import logo from '../../static/icons/logo.svg'
import Alert from '../../ui/Alert/Alert'
import { FancyLoader } from '../../ui/FancyLoader'
import { Menu } from '../Menu'

const MainContent = () => {
  const { isLoading, getUserInfo, logout } = useAuth()
  const { t } = useTranslation()

  if (isLoading) {
    return <FancyLoader text={t('General.Loading')} />
  }

  const user = getUserInfo()

  return (
    <Router>
      <div className="App h-full flex flex-col">
        <header className="flex justify-between items-center p-4 bg-gray-100">
          <div className="flex">
            <img src={logo} className="h-10 w-10 mr-4" alt="logo" />
            <h1 className="text-xl font-bold">{t('General.Title')}</h1>
          </div>
          <div className="flex items-center">
            <p className="mr-4">
              {t('General.Greetings', { name: user?.name })}
            </p>
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
              onClick={logout}
            >
              {t('General.Logout')}
            </button>
          </div>
        </header>
        <main className="flex flex-1 overflow-hidden">
          <div className="w-64 h-full overflow-auto">
            <Menu />
          </div>
          <div className="flex-1 h-full overflow-auto">
            <AlertProvider
              template={Alert}
              timeout={ALERT_HIDE_TIMEOUT}
              containerStyle={ALERT_STYLE}
            >
              <AppRouter />
            </AlertProvider>
          </div>
        </main>
      </div>
    </Router>
  )
}

export default MainContent
